import { useState, useEffect } from "react";
import { Box, Typography, TextField, Button, Paper } from "@mui/material";
import { API_BASE_URL } from "../config";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";

const Settings = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");
  const rawRole = localStorage.getItem("role");
  const role = rawRole === "admin" ? "admin" : "user";
  const apiPrefix =
    role === "admin" ? "/api/admin/profile" : "/api/user/profile";

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}${apiPrefix}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setName(data.name || "");
        setEmail(data.email || "");
      })
      .catch(() => setError("Failed to load profile."));
  }, [token, apiPrefix]);

  const handleUpdate = async () => {
    if (!name || !email) return setError("Name and email are required.");
    if (!password) return setError("Password is required.");

    try {
      const res = await fetch(`${API_BASE_URL}${apiPrefix}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          name,
          email,
          password,
        }),
      });

      if (res.ok) {
        setSuccess("Profile updated successfully.");
        setPassword("");
        setError("");
      } else {
        const err = await res.json();
        setError(err.error || "Update failed.");
        setSuccess("");
      }
    } catch (err) {
      console.error(err);
      setError("Server error.");
      setSuccess("");
    }
  };

  return (
    <>
      <Box maxWidth="500px">
        <Typography variant="h5" fontWeight={500} mb={2}>
          Settings
        </Typography>

        {error && (
          <Typography color="error" mb={2}>
            {error}
          </Typography>
        )}
        {success && (
          <Typography color="green" mb={2}>
            {success}
          </Typography>
        )}

        <Paper sx={{ p: 3 }}>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            sx={{ mb: 2 }}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            sx={{ mb: 2 }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
            To change your password, simply enter a new password below.
          </Typography>
          <TextField
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="contained"
            onClick={handleUpdate}
            sx={{
              background: "var(--gradient-color)",
              borderRadius: 30,
              color: "#fff",
            }}
          >
            Save Changes
          </Button>
        </Paper>
      </Box>
    </>
  );
};

export default Settings;
